<app-dialog [show]="show" [header]="'Edit User'">
  <div class="suspend-user-container">
    <div class="label">
      <div class="header">Suspend Account</div>
      <div class="sub-header">
        Suspended users cannot login
      </div>
    </div>
    <app-switcher (ngModelChange)="changeSuspend()" [(ngModel)]="suspendUser"></app-switcher>
  </div>

  <form class="invite-form form" [formGroup]="editUserForm" (ngSubmit)="edit()">
    <div class="inputs-container">
      <app-input class="half-width"
                 formControlName="firstName"
                 [label]="'First Name'"
                 [placeholder]="'First Name'"
                 [autofocus]="show"
                 (keyupEnter)="focusInput('lastNameInput')"
                 (keydownTab)="focusInput('lastNameInput')"
      ></app-input>

      <app-input class="half-width"
                 formControlName="lastName"
                 [label]="'Last Name'"
                 [placeholder]="'Last Name'"
                 (keyupEnter)="focusInput('emailInput')"
                 (keydownTab)="focusInput('emailInput')"
                 #lastNameInput
      ></app-input>
    </div>

    <div class="inputs-container last">
      <app-input class="half-width"
                 formControlName="email"
                 [label]="'Email'"
                 [placeholder]="'user@example.com'"
                 (keyupEnter)="openDropdown()"
                 (keydownTab)="openDropdown()"
                 type="email"
                 #emailInput
      ></app-input>

      <app-dropdown class="half-width"
                    [label]="'Role'"
                    [placeholder]="'Role'"
                    formControlName="role"
                    [isOptionObject]="true"
                    [radioButtons]="true"
                    [options]="userRolesOptions"
                    #roleDropdown
      ></app-dropdown>
    </div>

    <div class="dialog-controls-default">
      <app-button customClasses="px-4"
                  [minWidth]="0"
                  text="Cancel"
                  subStyle="transparent"
                  class="cancel-btn"
                  (clicked)="close()"
      >
      </app-button>

      <app-button customClasses="px-4"
                  text="Save Changes"
                  class="invite-btn"
                  [type]="'submit'"
                  [disabled]="suspendUser ? false : editUserForm.invalid"
      >
      </app-button>
    </div>
  </form>
</app-dialog>
